module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[100]343.97ec217.woff2";